import React from 'react';
import MainPanel from '../../components/layout/MainPanel';
import { useDashboardData } from '../../components/DashboardShell';
import { useLocale } from '../../context/LocaleContext';

export default function HelpLocales() {
  const { data } = useDashboardData();
  const { t } = useLocale();
  const locales = data?.help?.locales || [];

  return (
    <MainPanel title={t('help.localesTitle')} subtitle={t('help.localesSubtitle')}>
      {locales.length === 0 ? (
        <div className="custio-empty" style={{ paddingTop: 24 }}>
          <p className="custio-empty__title">{t('help.localesEmpty')}</p>
          <p style={{ fontSize: 14, margin: 0, color: '#9ca3af' }}>{t('help.localesEmptyBody')}</p>
        </div>
      ) : (
        <ul style={{ margin: 0, paddingLeft: 20, color: '#e5e7eb', lineHeight: 1.8 }}>
          {locales.map((loc) => (
            <li key={loc}>{loc}</li>
          ))}
        </ul>
      )}
    </MainPanel>
  );
}
